export const arrayEquals = (a: Array<unknown>, b: Array<unknown>) => {
    return JSON.stringify(a) === JSON.stringify(b)
}